import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let id = useDataValue({
    viewPath: props.viewPath,
    context: 'thread',
    path: 'users[0].id',
  })

  return {
    variables: {
      id,
    },
    pause: !id,
    requestPolicy: 'cache-and-network',
  }
}
